<template>
    <b-list-group>
            <b-list-group-item 
                class="flex-column align-items-start">
                <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{file.name}}</h5>
                <b-button v-if="error"
                    size="sm" 
                    variant="danger" 
                    v-b-tooltip.hover title="Quitar de la lista"
                    @click="eliminaDocumento()">
                    <i class="fa fa-close"></i>
                </b-button>
                </div>
                
                <p v-if="error"
                    class="mb-1" 
                    style="color: #FF0000"
                    >{{error}}</p>
                
                <b-progress 
                    v-if="!terminado"
                    :value=progreso
                    :max=100 
                    show-progress 
                    animated
                    ></b-progress>
            </b-list-group-item>
        </b-list-group>
</template>

<script>
import axios from 'axios'
import { mapGetters } from "vuex";

export default {
    name: 'SubeDoc',
    props: ["file","tipoItem"],
    computed: {
        ...mapGetters([
        "httpURL",
        "sessionToken",
        ])
    },
    data: function () {
        return {
            enviando: false,
            id: this.$route.params.id,
            error: null,
            progreso:0,
            terminado: false
        }
    },
    created(){
        //Se manda el archivo al servidor
        const formData = new FormData();
        formData.append('documento',this.file);
        axios.put(this.httpURL+'/transparencia/normatividad/'+this.tipoItem+'/'+this.id+'/doc',
                formData,
                {
                    headers: {token:this.sessionToken},
                    onUploadProgress: e => this.progreso = Math.round(e.loaded * 100 / e.total)
                })
            .then(res => {
                this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                            text: res.data.mensaje });
                this.terminado = true;
                this.$emit('documentoCargado',res.data.doc);
                this.$emit('eliminaDocumento');
            })
            .catch(error => {
                if(error.response){
                    this.error = error.response.data.mensaje;
                    //console.log(error.response);
                    // this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                    //     text: error.response.data.mensaje });
                }else if( error.request){
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: 'No se pudo establecer una conexión al servidor.' });
                }
            });
    },
    methods: {
        eliminaDocumento(){
            this.$emit('eliminaDocumento');
        }
    }
}

</script>

<style>
    
</style>